import React, { useEffect, useState } from "react";
import {
  FolderIcon,
  UserIcon,
  ChartSquareBarIcon,
  HeartIcon,
} from "@heroicons/react/outline";
import RelationshipManagerCard from "../../components/dashboard/RelationshipManagerCard";
import ProfileDetailSection from "../../components/dashboard/ProfileDetailSection";
import Tooltip from "../../components/propertyDetail/Tooltip";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import { getBidInterest } from "services";

const navigation = [
  {
    name: "Dashboard",
    href: "/dashboard/shortlisted",
    icon: ChartSquareBarIcon,
    current: false,
  },
  {
    name: "Shortlisted assets",
    href: "/dashboard/shortlisted",
    icon: HeartIcon,
    current: true,
  },
  {
    name: "Enquired assets",
    href: "/dashboard/enquired-assets",
    icon: FolderIcon,
    current: true,
  },
  {
    name: "Profile",
    href: "/dashboard/profile",
    icon: UserIcon,
    current: true,
  },
];

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

export default function DashboardSidebar() {
  const router = useRouter();
  const [enquiryCount, setEnquiryCount] = useState(0);
  const shortlistedProperties = useSelector((state: any) => {
    return state.auth?.user?.profile?.meta?.shortlisted_properties;
  });

  const userUuid = useSelector((state: any) => {
    return state.auth?.user.uuid;
  });

  const subscription = useSelector((state: any) => {
    return state.auth?.subscription;
  });

  useEffect(() => {
    init(userUuid);
  }, [userUuid]);

  const init = async (uuid: any) => {
    const data: any = await getBidInterest(uuid);
    if (data) {
      setEnquiryCount(data.length);
    }
  };
  // The count may defer: what if property got deleted, should we remove from shortlisted
  const getLength = (key: string) => {
    switch (key) {
      case "shortlisted":
        if (shortlistedProperties) {
          if (shortlistedProperties.length === 0) {
            return "";
          }
          if (
            shortlistedProperties.length > 0 &&
            shortlistedProperties.length < 10
          ) {
            return `(0${shortlistedProperties.length})`;
          }
          if (shortlistedProperties.length >= 10) {
            return `(${shortlistedProperties.length})`;
          }
        } else {
          return "";
        }
        break;
      case "enquiredProperty":
        if (enquiryCount) {
          if (enquiryCount === 0) {
            return "";
          }
          if (enquiryCount > 0 && enquiryCount < 10) {
            return `(0${enquiryCount})`;
          }
          if (enquiryCount >= 10) {
            return `(${enquiryCount})`;
          }
          return enquiryCount;
        } else {
          return "";
        }
        break;
      default:
        break;
    }
  };

  return (
    <div className="hidden md:inset-y-0 md:flex md:w-full md:flex-col">
      <div className="flex flex-grow flex-col overflow-y-auto border-r border-l border-b border-gray-200 bg-white pt-5">
        <div>
          <div className="flex flex-shrink-0 items-center px-4">
            <ProfileDetailSection />
          </div>
        </div>

        <div>
          <div className="flex flex-grow flex-col">
            <nav className="flex-1 pb-4">
              {navigation.map((item, index) =>
                item.current ? (
                  <div
                    key={item.name}
                    onClick={() =>
                      router.push(item.href, undefined, { shallow: true })
                    }
                    className={classNames(
                      router.pathname.match(item.href)
                        ? "bg-gray-100 text-blue-600 border-r-4 border-r-blue-600"
                        : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                      "group flex items-center px-5 py-5 text-sm font-medium border-t cursor-pointer",
                      index === navigation.length - 1 ? "border-b" : ""
                    )}
                  >
                    <item.icon
                      className={classNames(
                        router.pathname.match(item.href)
                          ? "text-blue-600 "
                          : "text-gray-400 group-hover:text-gray-500",
                        "mr-3 flex-shrink-0 h-6 w-6"
                      )}
                      fill={
                        router.pathname.match(item.href)
                          ? item.name === "Shortlisted assets"
                            ? "#2563eb"
                            : "#ffffff"
                          : "#ffffff"
                      }
                      aria-hidden="true"
                    />
                    {item.name === "Shortlisted assets"
                      ? `${item.name} ${getLength("shortlisted")}`
                      : item.name === "Enquired assets"
                      ? `${item.name} ${getLength("enquiredProperty")}`
                      : item.name}
                  </div>
                ) : (
                  <Tooltip text="Coming Soon" key={index}>
                    <a
                      key={item.name}
                      href={item.href}
                      className={classNames(
                        item.current
                          ? "bg-gray-100 text-blue-600 border-r-4 border-r-blue-600"
                          : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                        "group flex items-center px-5 py-5 text-sm font-medium border-t",
                        index === navigation.length - 1 ? "border-b" : ""
                      )}
                    >
                      <item.icon
                        className={classNames(
                          item.current
                            ? "text-blue-600"
                            : "text-gray-400 group-hover:text-gray-500",
                          "mr-3 flex-shrink-0 h-6 w-6"
                        )}
                        aria-hidden="true"
                      />
                      {item.name}
                    </a>
                  </Tooltip>
                )
              )}
            </nav>
          </div>
        </div>

        <div className="pt-4">{/* {<RelationshipManagerCard />} */}</div>
      </div>
    </div>
  );
}
